import React, {Component} from "react";
import {Button, message, Switch} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import {hasAuth} from "../../../utils/NHCore";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import css from './index.css';
import NHContainerFrame from '../../common/NHContainerFrame';
import ViewForm from './ViewForm';
import EditForm from './edit-form/EditForm.js';

const basicUrl = '/xxcj/bdgl/';

/**
 * @author weishihuai
 * @date 2018/6/28
 * @time 16:06
 * @Description: 迎新系统-表单管理
 */
class IndexComponet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},            //初始化表单信息
            frameVisibleMap: {
                tableFlag: true,         //列表Tab显示标志
                addFlag: false,          //新增Tab显示标志
                updateFlag: false,       //修改Tab显示标志
                viewFlag: false,         //查看Tab显示标志
                showOperationBtn: false, //按钮显示标志
            },
            tempData: {},                //当前操作的行数据
            tyzt: '',                    //停用状态
            qyzt: '',                    //启用状态
        };
    }

    componentDidMount() {
        NHFetch("/proData/selectDataList", "GET", {sign: 'dmk_xtgl_zt'})
            .then(resData => {
                if (resData.data != null) {
                    if (resData.data[0] != null && resData.data[1] != null && resData.data[0].VALUE === '1' && resData.data[1].VALUE === '0') {
                        this.setState({tyzt: resData.data[1].LABEL, qyzt: resData.data[0].LABEL});
                    }
                }
            })
    }

    //设置当前显示页面
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            frameVisibleMap[name] = name === showFlagName;
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    };

    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
        this.refs.nhTable.filterTableData();
    };

    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setCurrentPageShow('addFlag');
    };

    //单行启用禁用
    updateStatus = (record, value) => {
        let PKID = record.PKID;
        NHFetch(basicUrl + "updateBdStatus", "POST", {"pkid": PKID, zt: value ? '1' : '0'})
            .then(res => {
                if (res && res.code === 200) {
                    message.success("操作成功");
                } else {
                    message.warn("操作异常");
                }
                this.refs.nhTable.readTableData();
            });
    };

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        let pkid = record.PKID;
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('updateFlag');
                }
            })
    };

    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({tempData: record});
        let pkid = record.PKID;
        NHFetch(basicUrl + pkid + '/get', 'GET')
            .then(res => {
                if (res) {
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('viewFlag');
                }
            })
    };

    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;
            this.handleDelete([pkid]);
        }, "warn");
    };

    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    };

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basicUrl + 'deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    if (res.data) {
                        message.success("删除操作成功！");
                        this.setState({showOperationBtn: false});
                        this.refs.nhTable.filterTableData();
                    }
                }
            })
    };

    // table选择row后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {
        this.setState({
            showOperationBtn: !!selectedRowKeys.length
        });
    };

    render() {
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'ROW_ID'
            }, {
                title: '表单标志',
                width: '150px',
                dataIndex: 'BDBZ',
                search: 'input',
                searchType:"input"
            }, {
                title: '表单名称',
                width: '200px',
                dataIndex: 'BDMC',
                search: 'input',
                searchType:"input"
            },
            {
                title: '表单采集提示',
                width: '150px',
                dataIndex: 'BDCJTS',
                search: 'input',
                searchType:"input"
            },
            {
                title: '采集开始时间',
                width: '150px',
                dataIndex: 'KSSJ',
                commonSearch: false,
                searchType:"datetime"
            },
            {
                title: '采集结束时间',
                width: '150px',
                dataIndex: 'JSSJ',
                commonSearch: false,
                searchType:"datetime"
            },
            {
                title: '状态',
                width: '150px',
                key: 'zt',
                dataIndex: 'ZT',
                commonSearch: false,
                render: (text, record) => {
                    const status = record.ZT === '1';
                    return (
                        hasAuth('zhxg_yxxt_xxcj_bdgl:updateStatus') ?
                            <Switch checkedChildren={this.state.qyzt} unCheckedChildren={this.state.tyzt}
                                    checked={status}
                                    onChange={(value) => this.updateStatus(record, value)}/> :
                            <span>{status ? this.state.qyzt : this.state.tyzt}</span>
                    );
                },
                searchType:"select"
            },
        ];

        //行内操作
        const action = [
            {title: '查看', onClick: this.handleViewBtnClick, auth: 'zhxg_yxxt_xxcj_bdgl:button_get'},
            {title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxxt_xxcj_bdgl:button_update'},
            {title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxxt_xxcj_bdgl:button_delete'}
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref="nhTable"
                             rowKey={record => record.PKID}
                             sign={'zhxg_yxxt_xxcj_bdgl_queryPage'}
                             columns={columns}
                             action={action}
                             rowSelectionChange={this.rowSelectionChange}>
                        {hasAuth("zhxg_yxxt_xxcj_bdgl:button_add") &&
                        <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>}
                        {(this.state.showOperationBtn && hasAuth("zhxg_yxxt_xxcj_bdgl:button_delete")) &&
                        <Button type="danger" ghost style={{marginLeft: 10}}
                                onClick={this.handleMultiDeleteBtnClick}>删除</Button>}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                                  title="新增表单配置"
                                  visible={this.state.frameVisibleMap.addFlag}
                                  footer={null}
                                  onCancel={this.handleCloseFrame}>
                    <EditForm ref="nhAddForm" onFinish={this.handleCloseFrame}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                                  title="修改表单配置"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  footer={null}
                                  onCancel={this.handleCloseFrame}>
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.viewFlag}
                                  title={this.state.tempData.BDMC + '—配置详情'}
                                  footer={null}
                                  onCancel={this.handleCloseFrame}>
                    <ViewForm initFormData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        );
    }
}

export default IndexComponet;



// WEBPACK FOOTER //
// ./components/xxcj/bdgl/index.js